var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      "item-text": _vm.itemText,
      "item-value": "id",
      label: _vm.label,
      placeholder: _vm.$t("search") + "...",
      rules: _vm.rules,
      loading: _vm.loading,
      disabled: _vm.disabled,
      "prepend-inner-icon": "mdi-domain",
      outlined: "",
      dense: "",
      clearable: "",
      "auto-select-first": "",
      "no-data-text": _vm.$t("no-results") || "No organizations found",
      filter: _vm.customFilter,
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c(
              "v-list-item-content",
              [
                _c("v-list-item-title", [_vm._v(_vm._s(_vm.itemText(item)))]),
                _c("v-list-item-subtitle", { staticClass: "text-caption" }, [
                  _vm._v(" " + _vm._s(item.id) + " "),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }